import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    CancelLogisticRequest,
    DeliverLogisticRequest,
    GetAllLogisticRequestById,
    InTransitIssueLogisticRequest,
    InTransitLogisticRequest,
    PreInTransitIssueLogisticRequest
} from "../../../../reduxToolkit/Logistics/logisticRequestSectionApi";
import { toast } from "react-toastify";
import CustomModal from "../../../../components/Modal/CustomModal";
import DivContainerBody from "../../../../components/DivContainerBody";
import { CustomTextField } from "../../../../components/CustomTextField";
import {errorMsg} from "../../../../Apis/functions";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 */
const RequestGenericCommentFieldModal = (props) => {
    const {
        onHide,
        title,
        setModified,
        modified,
        row,
        preIntransitComment,
        IntransitComment,
        inTransitIssueComment,
        deliverComment,
        cancelComment,
    } = props;

    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [comment, setComment] = useState('');
    const [emptyFields, setEmptyFields] = useState(false);

    useEffect(() => {
        if (row !== null && typeof row !== "undefined"){
            dispatch(GetAllLogisticRequestById(row.id));
        }
    }, [row]);

    const handleChange = (e) => {
        setComment(e.target.value);
    };

    const resetValues = () => {
        setComment('');
    };

    const handleSubmit = () => {
        if (!comment.trim()) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);

        let payload = {
            logisticRequestId: row?.id,
            supplierId: row?.supplierId,
            comment
        };

        let action;
        const commentToast = 'has_been_comment_successfully';

        switch (true) {
            case preIntransitComment:
                action = PreInTransitIssueLogisticRequest;
                break;
            case IntransitComment:
                action = InTransitLogisticRequest;
                break;
            case inTransitIssueComment:
                payload = {
                    logisticRequestId: row?.id,
                    supplierId: row?.supplierId,
                    comment
                };
                action = InTransitIssueLogisticRequest;
                break;
            case deliverComment:
                payload = {
                    logisticRequestId: row?.id,
                    supplierId: row?.supplierId,
                    comment
                };
                action = DeliverLogisticRequest;
                break;

            case cancelComment:
                action = CancelLogisticRequest;
                break;
            default:
                action = null;
        }

        if (typeof action !== 'function') {
            toast.error(t('action_not_defined'));
            return;
        }

        dispatch(action(payload))
            .then(({ payload: { data: { success,code } } }) => {
                if (success) {
                    toast.success(t(commentToast));
                    setModified(!modified);
                    onHide();
                } else {
                    errorMsg(code);
                }
            });
    };

    useEffect(() => {
        resetValues();
        setEmptyFields(false);
    }, [onHide]);

    return (
        <CustomModal
            {...props}
            title={t(title)}
            size='lg'
            onConfirm={handleSubmit}
            onHide={() => {
                onHide();
                resetValues();
            }}
            classNameBody="pt-2"
        >
            <DivContainerBody>
                <div className={"mt-3"}>
                    <CustomTextField
                        length={512}
                        id='txt_rgc_comment'
                        name='comment'
                        value={comment}
                        trans='comment'
                        emptyFields={emptyFields}
                        required={true}
                        onChange={handleChange}
                        multiline={true}
                        row={4}
                    />
                </div>
            </DivContainerBody>
        </CustomModal>
    );
};

export default RequestGenericCommentFieldModal;
